module.exports = __webpack_public_path__ + "14four/static/media/qr-remote.16cf83b4.png";